var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgFilePdfIconinline = function SvgFilePdfIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 34
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-284-378H996v774H-284z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB5756",
    d: "M2 0h14l10 10.105V32a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF2C2C",
    d: "M16 0l10 10h-8a2 2 0 01-2-2V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5.67 20.422V23H4.246v-7.11h2.832c.817 0 1.46.209 1.929.626.469.416.703.965.703 1.645s-.234 1.227-.703 1.64c-.469.414-1.112.62-1.929.62H5.671zm0-1.099h1.407c.397 0 .698-.108.903-.324.206-.217.308-.493.308-.828 0-.342-.102-.624-.305-.847-.204-.223-.505-.335-.906-.335H5.671v2.334zM10.76 23v-7.11H13.2c.87 0 1.585.278 2.149.833.563.555.844 1.267.844 2.136v1.177c0 .873-.281 1.585-.844 2.136-.564.552-1.28.828-2.149.828H10.76zm1.426-6.01v4.916h.942c.511 0 .911-.172 1.201-.517.29-.345.435-.796.435-1.353V18.85c0-.55-.145-.998-.435-1.343-.29-.345-.69-.518-1.201-.518h-.942zm9.53 3.056h-2.978V23h-1.425v-7.11h4.902v1.1h-3.477v1.957h2.979v1.099z"
  }))));
};
export default SvgFilePdfIconinline;